const constants = {
  BUYER_URL: ["/buyer-profile"],
  ORG_URL: [
    "/organization/register",
    "/organization/dashboard",
    "/organization/showings-list/:id",
  ],
  ADMIN_URL: [
    "/admin/manage-organizations",
    "/admin/manage-buyers",
    "/admin/manage-realtor",
    "/admin/showings-list/:id",
  ],
  ROLE: {
    BUYER: "client",
    REALTOR: "user",
    CONTACT: "contact",
    ADMIN: "admin",
    ORGANISATION: "organisation",
  },
  REDIRECT_URL: {
    BUYER_PROFILE: "/buyer-profile",
    LOGIN: "/register",
    FACESNAP: "/facesnap/register",
    CHECKOUT: "/checkout",
    ADMIN: "/admin/manage-organizations",
    ORGANISATION: "/organization/register",
    ORGANISATION_DASHBOARD: "/organization/dashboard",
  },
  MESSAGE: {
    INVALID_EMAIL: "Please enter a valid email.",
    SOMETHING_WRONG: "Something went wrong, please try after some time.",
    LICENCE_SUCCESS: "Licence added successfully",
    UPLOAD_ERROR:
      "There was an error uploading your photo, try reducing the file size.",
    UNSUPPORTED_FILE: "Unsupported file format",
    NAME_ERROR: "Please enter a valid name",
    PASSWORD_ERROR: "Please enter a valid password without space",
    PREMIUM_FAIL: "Please upgrade to premium subscription.",
    BLOCKED_USER: "Account is blocked",
  },
  EMAIL_REGEX: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
  COMMON_MESSAGE: {
    SERVER_ERROR: "Internal server error",
  },
  PROFILE_IMAGE_MIME: ["image/png", "image/jpeg", "image/jpg"],
  ERROR_CODE: 403,
  ERROR_STATUS: 401,
};

export default constants;
